import PropTypes from 'prop-types';
import { Box, Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import MetricValue from './MetricValue';
import i18n, { t } from '../../i18n';

const metrics = [
    ['managers', 'Gestores ativos', SupervisorAccountOutlinedIcon],
    ['administratives', 'Administrativos ativos', BadgeOutlinedIcon]
];
export default function AdministrativeTeam({ overview }) {
    const short = useMediaQuery('(max-height:499.95px)');
    const number = new Intl.NumberFormat(i18n.resolvedLanguage === 'en' ? 'en-GB' : 'pt-PT');
    return <Box component="section" aria-label={t('Equipa administrativa')} aria-busy={overview.isPending}
        sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography component="h2" variant="h4" color="primary.main" sx={{ fontSize: { xs: 15, sm: 17 } }}>
                {t('Equipa administrativa')}
            </Typography>
        </Stack>
        <Box sx={{ flex: 1, minHeight: 0, display: 'grid', alignItems: 'center', mt: 1,
            gridTemplateColumns: short ? 'repeat(2, minmax(0, 1fr))'
                : { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' }, gap: short ? 1 : 2 }}>
            {metrics.map(([key, label, Icon]) => <MetricValue key={key} label={label} icon={Icon} short={short} large
                value={overview.isPending ? <Skeleton width={48} sx={{ animationDuration: '2.2s',
                    '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }} />
                    : overview.isError || overview.data?.[key] == null ? '—' : number.format(overview.data[key])} />)}
        </Box>
    </Box>;
}
AdministrativeTeam.propTypes = { overview: PropTypes.object.isRequired };
